module.exports = __webpack_public_path__ + "static/media/sparrow-with-kalli.9d644be2.png";